import * as React from 'react';
import { createRoot } from 'react-dom/client';
import type { NonInteractiveContinueHandlerType, NonInteractiveRenderViewReturnType, RenderViewPropsType, RenderViewReturnType } from '../types';
import { CtaButton } from '../../../React/features/Chat/features/CtaButton';

export const COMPONENT_IDENTIFIER = 'cta-button';
const COMPONENT_ROOT_CLASS_NAME = `chat-${COMPONENT_IDENTIFIER}-container`;

export type RenderCtaButtonPropsType = RenderViewPropsType<{
  waitTime?: number;
}>

export const renderCtaButton = async (props: RenderCtaButtonPropsType): RenderViewReturnType<NonInteractiveRenderViewReturnType> => {
  const { chatRoot } = props;

  // レンダーするためのルート要素を作成
  const viewContainer = document.createElement('div');
  const viewRoot = createRoot(viewContainer);

  // コンテナ要素にクラス付与
  viewContainer.classList.add(COMPONENT_ROOT_CLASS_NAME);

  // チャットルートにコンテナ要素をappendする
  chatRoot.appendChild(viewContainer);

  return new Promise((resolve) => {
    const continueHandler = (args: NonInteractiveContinueHandlerType) => resolve({ ...args, viewRootDomReference: viewContainer });

    // appendしたコンテナ要素にJsxをレンダリングする
    viewRoot.render(<CtaButton {...props} continueHandler={continueHandler} />);
  });
};
